import { render, staticRenderFns } from "./livebroadcast.vue?vue&type=template&id=555c6853&scoped=true&"
import script from "./livebroadcast.vue?vue&type=script&lang=js&"
export * from "./livebroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c6853",
  null
  
)

export default component.exports